import { useContext, useEffect, useState } from "react";
import IRMA from "@models/IRMA";
import RmaService from "@services/RmaService";
import UserContext from "@contexts/UserContext";
import SupplierContext from "@contexts/SupplierContext";

interface UseRmaDetailReturn {
    rma: IRMA | null;
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

export const useRmaDetail = (rmaGuid: string): UseRmaDetailReturn => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [rma, setRma] = useState<IRMA | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchRma = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await RmaService.getRma(rmaGuid, userModel, supplierModel);

            if (response.success && response.rma) {
                setRma(response.rma);
            } else {
                setError(response.message || "Failed to fetch RMA");
            }
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "An error occurred while fetching RMA";
            setError(errorMessage);
            console.error("Error fetching RMA:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (rmaGuid && userModel && supplierModel) {
            fetchRma();
        }
    }, [rmaGuid]);

    return {
        rma,
        loading,
        error,
        refetch: fetchRma,
    };
};
